import { LocationSelectable, LocationsDTO } from '@hakimo-ui/hakimo/types';
import { useHttpClient } from '@hakimo-ui/hakimo/util';
import { NEGATIVE_FILTER_TOKEN, SEPARATOR } from '../shared';

/**
 * @param tap run any side-effects
 * @returns
 */
export function useLocationsByName(
  tap?: (response: Response) => void,
  isAlarmGroups?: boolean
) {
  const httpClient = useHttpClient();

  return (name: string) => {
    const params = new URLSearchParams({ name });
    if (isAlarmGroups !== undefined) {
      const query = ['vision'];
      if (!isAlarmGroups) {
        query.push(NEGATIVE_FILTER_TOKEN);
      }
      params.set('sourceSystem', query.join(SEPARATOR));
    }
    const url = `/v2/orm/locations?${params.toString()}`;

    return httpClient<LocationSelectable[]>(url, {
      responseModifier: async (response) => {
        const res = await response.json();
        const payload = res.payload as LocationsDTO;
        return payload.items.map<LocationSelectable>((item) => ({
          id: String(item.id),
          name: item.name,
          tenant_id: item.tenant_id,
        }));
      },
      tap,
    });
  };
}

export default useLocationsByName;
